module.exports = __webpack_public_path__ + "static/hallmark-logo-d85549e2465b1807dfc5aa7020c78fc2.png";